module.exports = __webpack_public_path__ + "static/media/java3.7a372568.png";